import {EntityData, field} from "@fedeltapointofsale/data-client";

export class StockTransferData extends EntityData<StockTransferData> {
    @field transferId: number;
}
